"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BasicToast = _interopRequireDefault(require("../BasicToast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/prop-types: "off" */
function createToastMiddleware() {
  return function () {
    return function () {
      return function (_ref) {
        var notification = _ref.notification;
        return /*#__PURE__*/_react.default.createElement(_BasicToast.default, {
          notification: notification
        });
      };
    };
  };
}

var _default = createToastMiddleware;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9jcmVhdGVUb2FzdE1pZGRsZXdhcmUudHN4Il0sIm5hbWVzIjpbImNyZWF0ZVRvYXN0TWlkZGxld2FyZSIsIm5vdGlmaWNhdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUVBOzs7O0FBTEE7QUFPQSxTQUFTQSxxQkFBVCxHQUFrRDtBQUNoRCxTQUFPO0FBQUEsV0FBTTtBQUFBLGFBQU07QUFBQSxZQUFHQyxZQUFILFFBQUdBLFlBQUg7QUFBQSw0QkFBc0IsNkJBQUMsbUJBQUQ7QUFBWSxVQUFBLFlBQVksRUFBRUE7QUFBMUIsVUFBdEI7QUFBQSxPQUFOO0FBQUEsS0FBTjtBQUFBLEdBQVA7QUFDRDs7ZUFFY0QscUIiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGVzbGludCByZWFjdC9wcm9wLXR5cGVzOiBcIm9mZlwiICovXG5cbmltcG9ydCB7IFRvYXN0TWlkZGxld2FyZSB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgQmFzaWNUb2FzdCBmcm9tICcuLi9CYXNpY1RvYXN0JztcblxuZnVuY3Rpb24gY3JlYXRlVG9hc3RNaWRkbGV3YXJlKCk6IFRvYXN0TWlkZGxld2FyZSB7XG4gIHJldHVybiAoKSA9PiAoKSA9PiAoeyBub3RpZmljYXRpb24gfSkgPT4gPEJhc2ljVG9hc3Qgbm90aWZpY2F0aW9uPXtub3RpZmljYXRpb259IC8+O1xufVxuXG5leHBvcnQgZGVmYXVsdCBjcmVhdGVUb2FzdE1pZGRsZXdhcmU7XG4iXX0=